export type UtilitiesIncludedProps = {
  hasAirConditioning: boolean;
  hasCableTv: boolean;
  hasElectricity: boolean;
  hasGarbage: boolean;
  hasGas: boolean;
  hasHeating: boolean;
  hasHotWater: boolean;
  hasInternet: boolean;
  hasSewage: boolean;
  hasWater: boolean;
};

const UtilitiesIncluded = ({
  hasAirConditioning = false,
  hasCableTv = false,
  hasElectricity = false,
  hasGarbage = false,
  hasGas = false,
  hasHeating = false,
  hasHotWater = false,
  hasInternet = false,
  hasSewage = false,
  hasWater = false,
}: Partial<UtilitiesIncludedProps> = {}): UtilitiesIncludedProps => ({
  hasAirConditioning: Boolean(hasAirConditioning),
  hasCableTv: Boolean(hasCableTv),
  hasElectricity: Boolean(hasElectricity),
  hasGarbage: Boolean(hasGarbage),
  hasGas: Boolean(hasGas),
  hasHeating: Boolean(hasHeating),
  hasHotWater: Boolean(hasHotWater),
  hasInternet: Boolean(hasInternet),
  hasSewage: Boolean(hasSewage),
  hasWater: Boolean(hasWater),
});

export default UtilitiesIncluded;
